var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon10BlogChecklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.57 2c.24 0 .43.19.43.42v19.15c0 .24-.19.43-.43.43H2.43a.42.42 0 0 1-.43-.43V2.43c0-.24.19-.43.42-.43h19.15m0-2H2.43A2.43 2.43 0 0 0 0 2.42v19.15A2.43 2.43 0 0 0 2.42 24h19.15A2.43 2.43 0 0 0 24 21.57V2.43A2.43 2.43 0 0 0 21.57 0z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.03 5.46h11.95m-9.96 8.5 2.65 2.65 5.31-5.31"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggZD0iTTIxLjU3IDJjLjI0IDAgLjQzLjE5LjQzLjQydjE5LjE1YzAgLjI0LS4xOS40My0uNDMuNDNIMi40M2EuNDIuNDIgMCAwIDEtLjQzLS40M1YyLjQzYzAtLjI0LjE5LS40My40Mi0uNDNoMTkuMTVtMC0ySDIuNDNBMi40MyAyLjQzIDAgMCAwIDAgMi40MnYxOS4xNUEyLjQzIDIuNDMgMCAwIDAgMi40MiAyNGgxOS4xNUEyLjQzIDIuNDMgMCAwIDAgMjQgMjEuNTdWMi40M0EyLjQzIDIuNDMgMCAwIDAgMjEuNTcgMHoiIGZpbGw9IiMwMDAiIC8+DQogICAgPHBhdGggc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTYuMDMgNS40NmgxMS45NW0tOS45NiA4LjUgMi42NSAyLjY1IDUuMzEtNS4zMSIvPg0KICA8L2c+DQo8L3N2Zz4NCg==";
export { SvgIcon10BlogChecklist as ReactComponent };